(function (angular, schoolwork12) {

    'use strict';

    angular.module(schoolwork12.app.mailTemplate.name)
      .controller(schoolwork12.app.mailTemplate.controllers.manageMailTemplate, [
        '$rootScope', '$scope', '$timeout', '$http', '$filter', '$uibModal',
         schoolwork12.app.auth.services.authentication,
         schoolwork12.app.common.services.eventNotification,
         schoolwork12.app.common.services.utilService,
         schoolwork12.app.mailTemplate.services.mailTemplateSvc,
        function ($rootScope, $scope, $timeout, $http, $filter, $uibModal,
        	authentication, eventNotification, utilService, mailTemplateSvc) {

        	console.info("In school mail template controller");
            eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn,
                function (event, authenticatedUser) {
                    console.info('Mail Template controller: Subscribe On UserLogin Event: '
                        .concat(angular.toJson(authenticatedUser)));
                	
                	// fetch list of schools when user navigates directly to url
                	$scope.schoollist = authentication.getSchools();
				
                });

            if (authentication.isAuthenticated()) {
                $scope.schoollist = authentication.getSchools();
            }

            //Initialize global variables
   			$scope.mailTemplateErrorMesg = "";
			$scope.mailTemplateErrorOccurred = false;	
            $scope.isMailTemplateSearchBusy = false;
			$rootScope.closeSuccess = false;
			$rootScope.closeWarning = false;
            $scope.modalInstanceTemplate = null;
			

			// Determines the Mail Template Search datepickers opening and closing
            $scope.datePickers = {
                createdDate: false,
                modifiedDate: false
            };

            $scope.openCreatedDate = function() {
                $scope.datePickers.createdDate = true;
            };

            $scope.openModifiedDate = function() {
                $scope.datePickers.modifiedDate = true;
            };

            //close success msg on click
            $scope.closeSuccessMsg = function() {
            	$rootScope.closeSuccess = true;
            }
            //close warning msg on click
            $scope.closeWarningMsg = function() {
            	$rootScope.closeWarning = true;
            }

            //Initialize manage mail template grid 
            $scope.gridOptions = {
                enableFiltering: true,
		     	rowHeight: 50,
				paginationPageSizes : [ 25, 50, 75 ],
				paginationPageSize : 25,
		    };

		     var actionCellTemplate = '<div class="ui-grid-cell-contents actionIcons" >' +  
		    '<span class="glyphicon glyphicon-edit" tooltip-placement="bottom" uib-tooltip="Edit School Mail Template" ui-sref="mailTemplate.editMailTemplate({ id: row.entity.templateId, templateName: row.entity.templateName, templateType: row.entity.templateType, subject: row.entity.subject, body: row.entity.body, schools: row.entity.schoolIds, created: row.entity.createdDate, modified: row.entity.modifiedDate, status: row.entity.status  })"></span>' + 
            '<span ng-if="grid.appScope.requestStatus==0" class="glyphicon glyphicon-ok-circle" tooltip-placement="bottom" uib-tooltip="Reactivate School Mail Template" ng-click="grid.appScope.changeStatus({ id: row.entity.templateId, templateName: row.entity.templateName, templateType: row.entity.templateType, subject: row.entity.subject, body: row.entity.body, schools: row.entity.schoolIds, created: row.entity.createdDate, modified: row.entity.modifiedDate, status: row.entity.status  })"></span>' + 
		    '<span ng-if="grid.appScope.requestStatus==1" class="glyphicon glyphicon-ban-circle" tooltip-class="tooltipBan" tooltip-placement="bottom" uib-tooltip="Deactivate School Mail Template" ng-click="  grid.appScope.changeStatus({ id: row.entity.templateId, templateName: row.entity.templateName, templateType: row.entity.templateType, subject: row.entity.subject, body: row.entity.body, schools: row.entity.schoolIds, created: row.entity.createdDate, modified: row.entity.modifiedDate, status: row.entity.status  })"></span>' + 
            '</div>';
		    

            //Build column definitions	
			$scope.gridOptions.columnDefs = [
                { field: 'templateId', displayName: 'Template ID', width: '11%'},
                { field: 'templateType', displayName: 'Template Type', width: '12%'},
                { field: 'templateName', displayName: 'Template Name'},
                { field: 'getSchoolList()', displayName: 'Schools', width: '21%'},
			    { field: 'modifiedDate', displayName: 'Modified Date', width: '12%', sortingAlgorithm: utilService.sortDateFn},
			    { field: 'createdDate', displayName: 'Created Date', width: '12%', sortingAlgorithm: utilService.sortDateFn},
			    { field: 'action', displayName: 'Action', width: '11%', cellTemplate: actionCellTemplate},
			];


            // Popup displayed when hitting the activate / deactivate icon in templates grid
            $scope.openAlertChangeStatus = function (template) {
                $scope.isActive =  (template.status == 1);                                

                $scope.modalInstanceTemplate = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'commonDialogTemplate.html',
                    windowClass: 'alert-Modal',
                    keyboard: false,
                    backdrop: 'static',
                    scope: $scope,
                    controller: ['$scope', '$uibModalInstance',
                    function ($scope, $uibModalInstance) {
                        $scope.ok = function () {                            
                            $uibModalInstance.close(true);

                            // Getting schoolIds by abbreviation
                            var selSchoolIds = [];
                            var selSchoolAbbr = template.schools;
                            for (var j in $scope.schoollist) {
                                for (var i in selSchoolAbbr) {
                                    if (selSchoolAbbr[i] == $scope.schoollist[j].abbreviation) {
                                        selSchoolIds.push($scope.schoollist[j].schoolId);
                                    }
                                }
                            }

                            var data = {                        
                                "templateName": template.templateName,
                                "schoolList": selSchoolIds,
                                "templateType": template.templateType,
                                "subject": template.subject,
                                "body": template.body || " ",
                                "status": (template.status == 1 ?  "0" : "1")
                            };
                            
                            console.info("Calling update school template svc for template " + template.id);                            
                            var mailTemplatePromise = mailTemplateSvc.updateSchoolTemplate(authentication.getCurrentUser().keycode, data, template.id);                            
                        };

                        var msg = (template.status == 1) ? 'Are you sure you want to Deactivate \''+ template.templateName +'\' ?':
                                                           'Are you sure you want to Reactivate \''+ template.templateName +'\' ?';
                        $scope.dialogMsg = msg;
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss('cancel');
                        };
                    }], 
                });
            };


			//Get mail template for selected school
			$scope.getMailTemplateList = function(){
                var mailTemplatePromise = null;
                $scope.displayGraduationPlanGrid = false;
                $scope.isMailTemplateSearchBusy = true;			   
			  
                var getMailTemplateListSvc = function(){
    				if($scope.selectedStatus=='Active'){
    					$scope.requestStatus = 1;
    				} else {
    					$scope.requestStatus = 0;
				    }

                    //get selected school/ all school list as an array
    			   	if($scope.selectedSchool != 'All'){
                        var selectedSchoolId = [];
                        var selectedSchoolObj = $scope.schoollist.filter(function (obj) { 
                          return obj.name === $scope.selectedSchool; 
                        });
                        
                        selectedSchoolId.push(selectedSchoolObj[0].schoolId);
    			   		$scope.selectedSchoolObj = selectedSchoolId;
    			   	} else {
                        var allSchoolList = _.pluck($scope.schoollist, 'schoolId');
    			   		$scope.selectedSchoolObj = allSchoolList;
    			   	}

    			   	var data = {
    			   		"templateName": $scope.templateName,
    					"createdDateQualifier": $scope.createdDateQualifier,
    					"createdDate": $filter('date')($scope.createdDate, 'MM/dd/yyyy'),
    					"modifiedDateQualifier": $scope.modifiedDateQualifier,
    					"modifiedDate":$filter('date')($scope.modifiedDate, 'MM/dd/yyyy'),
    					"schoolIds": $scope.selectedSchoolObj,
    					"status": $scope.requestStatus
                    };

                    if ($scope.isSearchValid()) {	 
                        $scope.isMailTemplateSearchBusy = true; 
    			   		mailTemplatePromise = mailTemplateSvc.templateSearch(authentication.getCurrentUser().keycode, data);
    	                mailTemplatePromise
    	                .then(
    	                		function (data) { 	
    							if (data.length > 0) {
    								console.info("Viewing template search grid"); 
    								$scope.isMailTemplateSearchBusy = false; 
    								$scope.mailTemplateErrorOccurred = false;
    								$scope.mailTemplateErrorMesg = " ";   
    								$scope.displayGraduationPlanGrid = true;
    			             	    $scope.gridOptions.data = data;

                                    angular.forEach($scope.gridOptions.data,function(row){
                                      row.getSchoolList = function(){
                                        // console.log(row)
                                        return (this.schoolIds.toString().replace(/\s/g, '').split(",").join(", "));
                                      }
                                    });

    							} else {
    								$scope.mailTemplateErrorOccurred = true;
    								$scope.mailTemplateErrorMesg = schoolwork12.app.errorMessages.noResultsFound;
    							}
    		             	 
    	                }, function (error) {
    	                    console.info('Error in viewing template search grid....'.concat(angular.toJson(error)));   
    	                    $scope.mailTemplateErrorOccurred = true;
    	                    $scope.mailTemplateErrorMesg = " "; 
    	                	if (error.status == 400) {
    							for ( var j = 0; j < error.data._errors.length; j++) {
    								$scope.mailTemplateErrorMesg = $scope.mailTemplateErrorMesg + error.data._errors[j] + "\n";
    							}
    						} else if (error.status == 401 || error.status == 403) {
    	                        $scope.mailTemplateErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
    	                    } else {
    	                        $scope.mailTemplateErrorMesg = schoolwork12.app.errorMessages.internalError;
    	                    }

                        })['finally']
        					(function() {
        						$scope.isMailTemplateSearchBusy = false;
        					});
				    }
                }

                // $scope.isMailTemplateSearchBusy = true;
                if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
                    console.info('Keycode found. Making a call to service');
                    //invoking getMailTemplateListSvc()
                    getMailTemplateListSvc();
                } else {
                    console.info('Key code not found. Using time out function to make a call');
                    $timeout(function () {
                        //invoking getMailTemplateListSvc()
                        getMailTemplateListSvc();
                    }, 500);
                }
            };

            //Change mail template status
            $scope.changeStatus = function(template){                         
                $scope.openAlertChangeStatus(template);
                event.preventDefault();
            };

        	$scope.isSearchValid = function() {
                $scope.isMailTemplateSearchBusy = false;
                return $scope.isValidCreatedDateAndQualifier() &&
                $scope.isValidModifiedDateAndQualifier();
            }

            $scope.isValidCreatedDateAndQualifier = function() {
                console.log("Validating Created Date and Qualifier");
                if (!$scope.mailTemplateSearchForm.createdDate.$valid) { 
                    $scope.mailTemplateErrorOccurred = true;
                    $scope.mailTemplateErrorMesg = schoolwork12.app.mailTemplate.errorMessages.invalidCreatedDt;
                    return false;
                } else if ($scope.createdDate != null 
                		&& !$scope.createdDateQualifier) {
                    $scope.mailTemplateErrorOccurred = true;
                    $scope.mailTemplateErrorMesg = schoolwork12.app.mailTemplate.errorMessages.selectCreatedDt;
                    return false;
                } else if ($scope.createdDate == null && 
                    $scope.createdDateQualifier != null &&
                    $scope.createdDateQualifier != '') {
                    $scope.mailTemplateErrorOccurred = true;
                    $scope.mailTemplateErrorMesg = schoolwork12.app.mailTemplate.errorMessages.invalidCreatedDtQualifier;
                    return false;
                }
                return true;
            }

            $scope.isValidModifiedDateAndQualifier = function() {
                console.log("Validating Modified Date and Qualifier");
                if (!$scope.mailTemplateSearchForm.modifiedDate.$valid) { 
                    $scope.mailTemplateErrorOccurred = true;
                    $scope.mailTemplateErrorMesg = schoolwork12.app.mailTemplate.errorMessages.invalidModifiedDt;
                    return false;
                } else if ($scope.modifiedDate != null 
                		&& !$scope.modifiedDateQualifier) {
                    $scope.mailTemplateErrorOccurred = true;
                    $scope.mailTemplateErrorMesg = schoolwork12.app.mailTemplate.errorMessages.selectModifiedDt;
                    return false;
                } else if ($scope.modifiedDate == null && 
                    $scope.modifiedDateQualifier != null &&
                    $scope.modifiedDateQualifier != '') {
                    $scope.mailTemplateErrorOccurred = true;
                    $scope.mailTemplateErrorMesg = schoolwork12.app.mailTemplate.errorMessages.invalidModifiedDtQualifier;
                    return false;
                }
                return true;
            }
    }]);

}(angular, schoolwork12));